<script setup lang="ts">
import { ref } from 'vue';
import IconButton from "~/components/ui/button/iconbutton.vue";
import CloseButton from "~/components/ui/button/iconbutton.vue";
import MobileGnb from "~/components/layout/mobilegnb.vue";

const open = ref<boolean>(false);
const afterOpenChange = (bool: boolean) => {
  console.log('open', bool);
};
const showDrawer = () => {
  open.value = true;
};
const closeDrawer = () => { open.value = false};
</script>

<template>
  <div class="mobile-menu-wrap">
    <IconButton class="mobile-menu-btn" @click="showDrawer">
      <img src="~/assets/img/mobile/mo-menu.svg" alt="menu" />
    </IconButton>
    <a-drawer
        v-model:open="open"
        class="mobile-menu-drawer"
        root-class-name="mobile-menu-wrap"
        placement="right"
        @after-open-change="afterOpenChange"
        :width="'100%'"
        :closable="false"
    >
      <template #title>
        <div class="mobile-menu-logo">
          <div class="mo-logo">
            <img src="~/assets/img/pc/main/logo.svg" alt="logo" />
          </div>
          <CloseButton @click="open = false" class="mo-close-button">
            <CloseOutlined />
          </CloseButton>
        </div>
      </template>
      <div class="mobile-menu-content">
          <div class="content-body">
              <MobileGnb @select="closeDrawer" />
          </div>
      </div>
    </a-drawer>
  </div>
</template>

<style scoped lang="scss">

</style>